<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">站点</span>
        <el-autocomplete
          v-model="parameterNames.channel_code_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          style="width: 250px"
          @focus="current = '站点'"
          @select="handleSelect"
          @clear="
            ;(parameterNames.channel_code_name = null),
              (parameter.channel_code = null)
          "
        />
      </div>
      <div class="item">
        <span class="item_title">平台</span>
        <el-autocomplete
          v-model="parameterNames.platform_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '平台'"
          @select="handleSelect"
          @clear="
            ;(parameterNames.platform_name = null),
              (parameter.platform_id = null)
          "
        />
      </div>
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放组'"
          @select="handleSelect"
          @clear="
            ;(parameterNames.release_group_id_name = null),
              (parameter.release_group_id = null)
          "
        />
      </div>
      <div class="item">
        <span class="item_title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投手'"
          @select="handleSelect"
          @clear="
            ;(parameterNames.pitcher_id_name = null),
              (parameter.pitcher_id = null)
          "
        />
      </div>
      <div class="item">
        <span class="item_title">书籍归属</span>
        <el-autocomplete
          v-model="parameterNames.book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书籍归属'"
          @clear="
            ;(parameterNames.book_id_name = null), (parameter.book_id = null)
          "
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">书名</span>
        <el-autocomplete
          v-model="parameterNames.alias_book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书名'"
          @clear="
            ;(parameterNames.alias_book_id_name = null),
              (parameter.alias_book_id = null)
          "
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">投放位置</span>
        <el-autocomplete
          v-model="parameterNames.position_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放位置'"
          @clear="
            ;(parameterNames.position_id_name = null),
              (parameter.position_id = null)
          "
          @select="handleSelect"
        />
      </div>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-search"
        @click="search()"
      >搜索</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <el-button
        style="height: 37px"
        type="primary"
        icon="el-icon-circle-plus"
        @click="establish"
      >创建</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column prop="id" label="id" />
        <el-table-column prop="channel_codes" label="站点" width="200">
          <template scope="scope">
            <ExpandClose
              :my-values="(scope.row.channel_names || []).slice().reverse()"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="ocean_advertiser_ids"
          label="巨量广告"
          width="300"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="
                scope.row.ocean_advertiser.map((item) => {
                  return `${item.account_name}（${item.account_id}）`
                })
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="adq_advertiser_ids"
          label="ADQ广告主"
          width="200"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="
                scope.row.adq_advertiser.map((item) => {
                  return `${item.account_name}（${item.account_id}）`
                })
              "
            />
          </template>
        </el-table-column>
        <el-table-column prop="platform_name" label="平台" />
        <el-table-column prop="release_group_name" label="投放组" />
        <el-table-column prop="pitcher_name" label="投手" />
        <el-table-column prop="novel_name" label="书名" width="120" />
        <el-table-column prop="belong_name" label="书籍归属" />
        <el-table-column prop="position_name" label="投放位置" />
        <el-table-column prop="begin_time" label="开始时间" />
        <el-table-column prop="end_time" label="结束时间" />
        <el-table-column prop="created_at" label="创建时间" />
        <el-table-column prop="updated_at" label="修改时间" />
        <el-table-column label="操作" min-width="150" fixed="right">
          <template scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="modify(scope.row)"
            >修改</el-button>
            <el-button
              type="primary"
              size="mini"
              @click="myDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="drawerItem && drawerItem.id ? '修改关系' : '创建关系'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      style="min-width: 680px"
      @closed="drawerItem = {}"
      @close="close"
    >
      <Details
        v-if="dialogVisible"
        ref="details"
        :drawer-item="drawerItem"
        @determine="determine"
      />
    </el-dialog>
  </div>
</template>

<script>
import {
  getBindingRelationSiteListNovel,
  getReleaseGroupListNovel,
  getListOfPitchersInTheLaunchGroupNovel,
  getTitleListNovel,
  getBookOwnershipListNovel,
  dropLocationListNovel,
  addReleaseRelationshipNovelSite,
  modifyReleaseRelationshipNovelSite,
  deleteReleaseRelationshipNovleSite,
  getTheListOfOfficialAccountNovelSite,
  getPlatform
} from '@/api/newLaunchGroup.js'
import { mapGetters } from 'vuex'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
import Details from './components/details.vue'
export default {
  components: {
    PaginationRight,
    ExpandClose,
    Details
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        channel_code: null, // 渠道号
        release_group_id: null,
        pitcher_id: null,
        alias_book_id: null,
        book_id: null,
        position_id: null
      },
      parameterNames: {
        channel_code: null, // 渠道号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null, // 投放位置
        channel_code_name: null
      },
      current: null,
      dialogVisible: false,
      drawerItem: {},
      isL: false,
      hasSearched: []
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters(['getBindingRelationship'])
  },
  methods: {
    // 获取数据列表
    async getDataList(obj = {}) {
      this.loading = true
      const data = await getBindingRelationSiteListNovel(
        Object.keys(obj).length ? obj : this.parameter
      )
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.isL = true
      this.drawerItem = row
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 确定
    async determine(obj) {
      const bool = !!this.drawerItem.id

      if (bool) {
        await modifyReleaseRelationshipNovelSite(this.drawerItem.id, obj)
      } else {
        await addReleaseRelationshipNovelSite(obj)
      }

      this.$message({
        message: bool ? '修改关系成功' : '创建关系成功',
        type: 'success'
      })
      this.isL = true

      this.drawerItem = {}
      this.dialogVisible = false
      this.reset()
    },

    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        投放组: 'release_group_name',
        投手: 'user_name',
        书籍归属: 'book_name',
        书名: 'novel_name',
        投放位置: 'position_name',
        站点: 'channel_code_name',
        平台: 'platform_name'
      }

      switch (this.current) {
        case '投放组':
          currentFunc = getReleaseGroupListNovel
          break
        case '投手':
          currentFunc = getListOfPitchersInTheLaunchGroupNovel
          break
        case '书名':
          currentFunc = getTitleListNovel
          break
        case '书籍归属':
          currentFunc = getBookOwnershipListNovel
          break
        case '投放位置':
          currentFunc = dropLocationListNovel
          break
        case '站点':
          currentFunc = getTheListOfOfficialAccountNovelSite
          break
        case '平台':
          currentFunc = getPlatform
          break
      }
      if (!currentFunc) {
        return
      }
      if (
        (this.current === '投手' && !this.parameter.release_group_id) ||
        (this.current === '书名' && !this.parameter.book_id)
      ) {
        const obj1 = {
          投手: '请先选投放组，才能选投手',
          书名: '请先选择书籍归属，才能选书名'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }

      let result = null
      console.log('item:', queryString)
      if (this.current === '站点' && queryString !== null) {
        result = queryString.replace(/\([^()]+\)/g, '')
      }
      if (this.current === '站点' && this.hasSearched.length !== 0) {
        var restaurants = this.hasSearched
        var results = result
          ? restaurants.filter(this.createFilter(result))
          : restaurants
        // 调用 callback 返回建议列表的数据
        console.log('results:', results)
        // cb(results)
        cb(
          results.map((item) => {
            return item
          })
        )
        return
      }

      const data = await currentFunc({
        name: this.current !== '站点' ? queryString : null,
        channel_name: this.current === '站点' ? result : null,
        group_id:
          this.current === '投手'
            ? this.parameter.release_group_id.address
            : null,
        book_belong_id: this.parameter.book_id
          ? this.parameter.book_id.address
          : null
      })
      cb(
        data.data.list.map((item) => {
          if (this.current === '站点') {
            this.hasSearched.push({
              value:
                this.current === '站点'
                  ? `${item.channel_name}(${item.platform_str})`
                  : this.current === '平台'
                    ? item.name
                    : item[obj[this.current]],
              address: this.current === '站点' ? item.channel_code : item.id
            })
          }
          return {
            value:
              this.current === '站点'
                ? `${item.channel_name}(${item.platform_str})`
                : this.current === '平台'
                  ? item.name
                  : item[obj[this.current]],
            address: this.current === '站点' ? item.channel_code : item.id
          }
        })
      )
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value
          .toLowerCase()
          .includes(queryString.toLowerCase())
      }
    },
    // 选中哪一项
    handleSelect(item) {
      console.log('item:', item)
      switch (this.current) {
        case '投放组':
          this.parameter.release_group_id = item
          break
        case '投手':
          this.parameter.pitcher_id = item
          break
        case '书名':
          this.parameter.alias_book_id = item
          break
        case '书籍归属':
          this.parameter.book_id = item
          break
        case '投放位置':
          this.parameter.position_id = item
          break
        case '站点':
          this.parameter.channel_code = item
          break
        case '平台':
          this.parameter.platform_id = item
          break
      }
    },

    // 搜索
    search(value) {
      value || (this.parameter.page = 1)
      const obj = {
        channel_code: 'channel_code_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map((key, index) => {
        if (
          this.parameter[key] &&
          this.parameter[key].value === this.parameterNames[obj[key]] &&
          key !== 'page' &&
          key !== 'pageSize'
        ) {
          obj1[key] = this.parameter[key].address
        } else if (
          key !== 'page' &&
          key !== 'pageSize' &&
          key !== 'channel_code'
        ) {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      this.getDataList(obj1)
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10,
        channel_code: null,
        release_group_id: null,
        pitcher_id: null,
        alias_book_id: null,
        book_id: null,
        position_id: null,
        platform_id: null
      }
      this.parameterNames = {
        channel_code: null, // 渠道号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null, // 投放位置
        channel_code_name: null,
        platform_name: null
      }
      this.current = null
      this.getDataList()
    },

    // 删除
    async myDelete(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await deleteReleaseRelationshipNovleSite(row.id)
        this.getDataList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },

    // 创建按钮的点击事件的处理函数
    establish() {
      // console.log('有无数据回显===', this.isL, this.drawerItem)
      this.drawerItem = this.getBindingRelationship || {}
      this.dialogVisible = true
      this.isL = false
    },

    close() {
      // this.isL || this.$store.commit('bindingRelationship/setLastCreatedData', this.$refs.details.createTheDesiredStructure())
      this.$store.commit(
        'bindingRelationship/setLastCreatedData',
        this.$refs.details.createTheDesiredStructure(this.isL)
      )
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content {
  .item {
    display: flex;
    align-items: center;
    .item_title {
      display: inline-block;
      width: 100px;
    }
    .item_input {
      width: 200px;
    }
  }
}

.selectionArea {
  display: flex;
  flex-wrap: wrap;
  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title {
      margin-right: 10px;
      display: inline-block;
    }
    .item_input {
      width: 200px;
    }
  }
}
</style>

<style>
.publicItems .el-dialog {
  margin-top: 6vh !important;
  min-width: 685px !important;
}
</style>
